<template>
    <modal :show-title="true" size="large" @close="$emit('close')" v-visibility-change="visibilityChange">
        <div slot="header">
            <h5 class="modal-title">{{$t('messaggeria')}}</h5>
        </div>
        <div slot="body" class="text-center">
            <p class="text-center" style="background: #f4f4f4; padding: 10px;">
                <span v-if="this.type === 'ORDINE'">
                    {{$t('carrello_ordine_label').capitalize()}}
                </span>
                <span v-else-if="this.type === 'PRENOTAZIONE'">
                    {{$t('prenotazione')}}
                </span>
                n. {{this.item.id}}
            </p>

            <div class="chat-rbox" style="height: 40vh; overflow-y: auto;">
                <div class="bg-warning text-white text-center py-2 mb-2" v-if="!this.f_enabled">
                    {{$t('limite_tempo_terminato')}}
                </div>
                <ul class="chat-list chat-container p-20" v-if="this.chat">
                    <!--chat Row ristorante -->
                    <li v-for="message in this.chat.messaggi"
                        :class="{'reverse': !message.id_utente}">
                        <div class="chat-img" v-if="message.id_utente">
                            <i class="fas fa-utensils fa-2x"></i>
                        </div>
                        <div class="chat-time" v-if="!message.id_utente">
                            {{moment(message.created_at).format("HH:mm")}}
                        </div>
                        <div class="chat-content">
                            <h5 v-if="message.id_utente">Ristorante</h5>
                            <h5 v-else>Io</h5>
                            <div class="box bg-light-info messaggeria-messaggio">
                                {{message.messaggio}}
                                <i class="fas fa-check"
                                   v-if="!message.id_utente"
                                   :class="{'text-info':message.data_ora_lettura}"></i>
                            </div>
                        </div>
                        <div class="chat-time" v-if="message.id_utente">
                            {{moment(message.created_at).format("HH:mm")}}
                        </div>
                        <div class="chat-img" v-if="!message.id_utente">
                            <i class="far fa-user-circle fa-2x"></i>
                        </div>
                    </li>
                </ul>
                <div class="text-center spinner-grow my-5" role="status" v-else-if="this.loading">
                    <span class="sr-only">Loading...</span>
                </div>
                <div class="text-center my-5" v-else>
                    {{$t('messaggistica_nessun_messaggio_disponibile')}}
                </div>
            </div>
            <div class="card-body b-t">
                <div class="row">
                    <div class="col-10">
                        <textarea :placeholder="$t('type_message_here')"
                                  class="form-control b-0"
                                  :disabled="!this.f_enabled"
                                  v-model="message_text"
                        ></textarea>
                    </div>
                    <div class="col-2 text-center" style="padding-top:6px;">
                        <button type="button" class="btn btn-info btn-circle btn-lg" style="padding:10px 12px;"
                                :disabled="!this.f_enabled || this.loading || this.sending"
                                @click="sendMessage()">
                            <i class="far fa-paper-plane fa-2x"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div slot="footer">
            <button type="button" class="btn btn-default" @click="$emit('close')">
                Ok
            </button>
        </div>
    </modal>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import {getChat, markChatMessages, sendChatMessage} from "../../../api/account";

    import Modal from "../../partials/Modal";

    export default {
        name: "ModalMessaging",
        components: {Modal},
        props: ['type', 'item'],
        data() {
            return {
                chat: null,

                loading: false,
                sending: false,
                f_enabled: true,

                message_text: ''
            }
        },
        created() {
            this.fetch();
        },
        computed: {
            ...mapState('localization', {
                language: state => state.language
            }),
            ...mapState('restaurant', {
                id_ristorante: state => state.id,
                locale: state => state.locale
            }),
            ...mapState('auth', {
                user: state => state
            }),
            ...mapState('chat', {
                unread_messages: state => state.unread_messages
            })
        },
        watch: {
            unread_messages: function () {
                this.fetch();
            }
        },
        methods: {
            fetch: function () {
                this.loading = true;
                getChat(this.language, {
                    id_ristorante: this.id_ristorante,
                    api_key: this.user.api_key,
                    chatable_type: this.type,
                    chatable_id: this.item.id
                }).then((response) => {
                    this.chat = response.chat;
                    this.f_enabled = response.f_enabled;

                    //TODO set timeout fine chat ???

                    if (this.chat) {
                        const unreadMsg = this.chat.messaggi.filter((obj) => {
                            return (!obj.data_ora_lettura && obj.id_utente);
                        }).map((obj) => obj.id);

                        if (unreadMsg.length) {
                            this.markAsRead(unreadMsg);
                        }

                        setTimeout(() => {
                            this.scrollToBottom();
                        }, 300);
                    }
                }).catch(({messages}) => {
                    alert(messages.join('\n'));
                }).finally(() => {
                    this.loading = false;
                })
            },
            sendMessage: function () {
                this.sending = true;
                sendChatMessage(this.language, {
                    id_ristorante: this.id_ristorante,
                    api_key: this.user.api_key,
                    chatable_type: this.type,
                    chatable_id: this.item.id,
                    message: this.message_text
                }).then((response) => {
                    if (this.chat) {
                        this.chat.messaggi.push(response.messaggio);
                    } else {
                        this.fetch();
                    }
                    this.message_text = '';

                    this.scrollToBottom();

                }).catch(({messages}) => {
                    alert(messages.join('\n'));
                }).finally(() => {
                    this.sending = false;
                })
            },
            markAsRead: function (ids) {
                markChatMessages(this.language, {
                    id_ristorante: this.id_ristorante,
                    api_key: this.user.api_key,
                    chatable_type: this.type,
                    chatable_id: this.item.id,
                    ids
                }).then((response) => {
                    this.removeUnreadMessages(ids);
                }).catch(({messages}) => {
                    alert(messages.join('\n'));
                });
            },
            scrollToBottom: function () {
                const $chatrbox = $('.chat-rbox');
                $chatrbox.animate({scrollTop: $chatrbox.prop("scrollHeight")}, 1000);
            },
            visibilityChange(evt, hidden) {
                // do something
                if (!hidden) {
                    this.fetch();
                }
            },
            ...mapActions('chat', [
                'removeUnreadMessages'
            ])
        }
    }
</script>
